import type { MemberRole } from "@cs2/contracts";
import {
  ONBOARDING_STEPS,
  type OnboardingChapter,
  type OnboardingStep,
} from "./onboarding-steps.js";

export type StepStatus = "done" | "skipped";
/** Status je Step-ID; fehlende IDs gelten als offen. */
export type OnboardingProgress = Readonly<Record<string, StepStatus>>;

export type ProgressSummary = {
  total: number;
  done: number;
  skipped: number;
  pending: number;
};

/** Nur Schritte, die die Rolle wirklich bedienen darf — optional je Kapitel. */
export function stepsFor(
  role: MemberRole,
  chapter?: OnboardingChapter,
): OnboardingStep[] {
  return ONBOARDING_STEPS.filter(
    (step) =>
      step.roles.includes(role) &&
      (chapter === undefined || step.chapter === chapter),
  );
}

export function pendingIn(
  steps: readonly OnboardingStep[],
  progress: OnboardingProgress,
): OnboardingStep[] {
  return steps.filter((step) => progress[step.id] === undefined);
}

export function summarize(
  steps: readonly OnboardingStep[],
  progress: OnboardingProgress,
): ProgressSummary {
  let done = 0;
  let skipped = 0;
  for (const step of steps) {
    if (progress[step.id] === "done") done += 1;
    else if (progress[step.id] === "skipped") skipped += 1;
  }
  return {
    total: steps.length,
    done,
    skipped,
    pending: steps.length - done - skipped,
  };
}
